import styled from 'styled-components'

export default styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 20px 30px;

  @media (min-width: 640px) {
    padding: 20px 60px 60px;
  }
`



// WEBPACK FOOTER //
// ./src/components/form/Form.js